import { EditIcon, TrashIcon } from '../../../../../assets/icons/common';
import { Experties } from '../../../../../store/workspace/types';
import { useDispatch } from '../../../../../store/store';
import styles from './style.module.scss';
import {
    setAddExpertiseModal,
    setExpertiseEditMode,
    setSelectedExpertise,
    setDeleteExpertiseModal,
} from '../../../../../store/workspace/slice';

interface Props {
    data: Experties[] | undefined;
};

export default function Expertise(props: Props) {
    const { data } = props;
    const copyOfData = (data && Array.isArray(data)) ? [...data] : null;
    const sortByOrder = copyOfData ? copyOfData.sort((a, b) => a.expert.orderId - b.expert.orderId) : null;
    const dispatch = useDispatch();

    const addExpertise = () => {
        if (!data || (data?.length > 2)) return;
        dispatch(setAddExpertiseModal(true));
    };

    const editExpertise = (item: Experties) => {
        dispatch(setExpertiseEditMode(true));
        dispatch(setSelectedExpertise(item));
        dispatch(setAddExpertiseModal(true));
    };

    const deleteExpertise = (item: Experties) => {
        dispatch(setSelectedExpertise(item));
        dispatch(setDeleteExpertiseModal(true));
    };

    return (
        <div className={styles.wrapper}>
            {sortByOrder?.map(item => <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>{item.expert.title}</span>
                    <div className={styles.content_headbar_actions}>
                        <EditIcon onClick={() => editExpertise(item)} />
                        <TrashIcon onClick={() => deleteExpertise(item)} />
                    </div>
                </div>
                <div className={styles.content_main}>
                    {item.skills.map(skill => <span className={styles.skill}>{skill.title}</span>)}
                </div>
            </div>)}
            <div
                className={styles.add_btn}
                data-is-deactive={!data || (data?.length > 2)}
                onClick={addExpertise}
            >
                <span>+ Add expertise</span>
            </div>
        </div>
    );
};